import axios from "axios";

export const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
const BASE = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";

export const api = axios.create({ baseURL: BASE, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ezjob_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const actAs = localStorage.getItem("ezjob_act_as");
  if (actAs && !config.url?.includes("/system/deployment")) {
    config.headers["X-EzJob-Act-As"] = actAs;
  }
  const trackId = localStorage.getItem("ezjob_active_track_id");
  if (trackId) config.headers["X-Career-Track-Id"] = trackId;
  return config;
});

export function setToken(token) {
  if (token) localStorage.setItem("ezjob_token", token);
  else localStorage.removeItem("ezjob_token");
}

export function setActAs(userId) {
  if (userId) localStorage.setItem("ezjob_act_as", userId);
  else localStorage.removeItem("ezjob_act_as");
}


export function apiErr(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d?.msg) return d.msg;
}
